import { SVGProps } from 'react';

const Pi = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 4v16M4 7c0-1.7 1.3-3 3-3h13m-2 16c-1.7 0-3-1.3-3-3V4"
    />
  </svg>
);
export default Pi;
